module.exports = __webpack_public_path__ + "img/tag1.b33e03c9.png";